export default __webpack_public_path__ + "static/media/ImpactoZ_Benjamin.5e271bed.png";